<template>
  <a-spin :spinning="loading" class="c-box">
    <div class="spin-content">
      <div class="wrapper">
        <a-row :gutter="16">
          <a-col :span="14">
            <h2>
              {{ course.is_group ? 'Kurs grupowy' : 'Kurs indywidualny' }}
            </h2>
            <h3><a-icon type="user" /> Lektor</h3>
            <p>{{ course.lecturer_name }}</p>
            <h3><a-icon :component="StudentSvg" /> Studenci</h3>
            <ul>
              <li v-for="(student, i) in course.students_name" :key="i">
                {{ student }}
              </li>
            </ul>
            <div v-if="course.deadline">
              <h3>Termin wykorzystania godzin:</h3>
              <p>{{ course.deadline }}</p>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </a-spin>
</template>

<script>
import { Course } from '@/api'
import StudentSvg from '@/assets/student.svg'

export default {
  data() {
    return {
      StudentSvg,
      course: {},
      loading: false
    }
  },
  created() {
    this.fetchCourse()
  },
  methods: {
    async fetchCourse() {
      this.loading = true
      Course.get(this.$route.params.courseId)
        .then(res => {
          this.course = res.data
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
